import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContextMenu',
  setup(__props) {

const network = computed(() => store.state.network);
const selectedNodes = computed(() => store.state.selectedNodes);

function pinSelectedNodes() {
  if (network.value !== null) {
    network.value.nodes
      .filter((node) => selectedNodes.value.has(node._id))
      .forEach((node) => {
        node.fx = node.x;
        node.fy = node.y;
      });
  }
}
function unPinSelectedNodes() {
  if (network.value !== null) {
    network.value.nodes
      .filter((node) => selectedNodes.value.has(node._id))
      .forEach((node) => {
        delete node.fx;
        delete node.fy;
      });
  }
}

const rightClickMenu = computed(() => store.state.rightClickMenu);

return { __sfc: true,network, selectedNodes, pinSelectedNodes, unPinSelectedNodes, rightClickMenu, store }
}

})